@if (globalSpinnerService.state | async; as state) {
    <div
        class="ca-spinner global-spinner flex-col justify-center items-center"
        [class.flex]="state.isShown"
        [attr.data-testid]="state.isShown ? 'global-spinner' : null"
    >
        <div class="global-spinner-content flex flex-col justify-center items-center">
            <div class="relative">
                <mat-spinner class="absolute spinner-track" mode="determinate" value="100" [diameter]="80"></mat-spinner>
                <mat-spinner [diameter]="80"></mat-spinner>
            </div>
            <div class="mt-6 ca-headline-1 mb-0" data-testid="global-spinner-text">{{ state.loadingText | translate }}</div>
            @if (state.loadingSubtext) {
                <div
                    class="ca-global-spinner-subtext text-center"
                    data-testid="global-spinner-subtext"
                    [innerHTML]="state.loadingSubtext | translate | markdownIt"
                ></div>
            }
            @if (state.hasCancel) {
                <button mat-button class="ca-button ca-button-m" (click)="globalSpinnerService.cancel()">
                    <ca-icon icon="cross" class="ca-icon-s-16-p-0-f-16"></ca-icon><span> {{ 'COMMON.BUTTONS.CANCEL' | translate }} </span>
                </button>
            }
        </div>
    </div>
}
